module.exports = __webpack_public_path__ + "static/assets/41e81e1b3a6ae71cb40aa3142e184de2.jpg";